export async function requestCnpjVerification({
  httpClient,
  cnpj,
  captchaToken,
  getFingerprintHeaders,
}) {
  const fingerprintHeaders = await getFingerprintHeaders();

  return httpClient.get("/register/verifyCNPJ", {
    params: { cnpj },
    headers: {
      "X-Recaptcha-Token": captchaToken,
      ...fingerprintHeaders,
    },
  });
}
